import React from 'react';

import { Box, Flex, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

type SkeletonProps = React.ComponentProps<typeof Skeleton>;

type ProjectItemSkeletonProps = {
	titleLength?: SkeletonProps['width'];
	subtitleLength?: SkeletonProps['width'];
};

/**
 * Skeleton loader for a single project item
 * Displays placeholder for project icon, name, and owner
 * @param titleLength - Width of the project title skeleton
 * @param subtitleLength - Width of the project subtitle skeleton
 */
export const ProjectItemSkeleton = ({
	titleLength = '270px',
	subtitleLength = '100px',
}: ProjectItemSkeletonProps): React.JSX.Element => (
	<Box>
		<Flex columnGap="space.100" alignItems="center">
			<Skeleton height="24px" width="24px" isShimmering />
			<Stack space="space.050" grow="fill">
				<Skeleton height="20px" width={titleLength} isShimmering />
				<Skeleton height="16px" width={subtitleLength} isShimmering />
			</Stack>
		</Flex>
	</Box>
);
